import React, { useState, useEffect } from "react";
import {
  Grid,
  Modal,
  TextField,
  Alert,
  Snackbar,
  Tooltip,
} from "@mui/material";
import { motion } from "framer-motion";
import EquipmentCard from "./EquipmentCard";
import { useMachineViewerData } from "./useMachineViewerData";
import Loading from "../Loading/Loading";
import { Button } from "@mui/material";
import * as S from "./styles";
import { postInsightwinMachineMaster } from "../../../utils/axios/axiosCall";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import MchSync from "./MchSync";
import SyncIcon from "@mui/icons-material/Sync";
import { CustomButton } from "../../common/Buttons";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import goToHelpLink from "../../../utils/goToHelpLink";

function generateRandomData(name, machine_id, original_name) {
  return {
    machine_id,
    name,
    original_name,
    failureRate: (Math.random() * 10).toFixed(1),
    bufferQuantity: Math.floor(Math.random() * 200) + 20,
    processingCapacity: Math.floor(Math.random() * 400) + 100,
    availableTime: Math.random() > 0.5 ? "24/7" : "8:00 AM - 5:00 PM",
    dedicatedWorker: [
      "John Doe",
      "Jane Smith",
      "Mike Johnson",
      "Emily Brown",
      "Robert Lee",
    ][Math.floor(Math.random() * 5)],
    schedule: ["Mon-Fri", "Mon-Sat", "Rotating Shifts", "Continuous"][
      Math.floor(Math.random() * 4)
    ],
  };
}

// 기준정보 - 장비관리 페이지
function FactoryEquipmentDashboard() {
  const { group_code, project_code } = useParams();
  const { loading, equipment, setUpdateStatus, updateStatus } =
    useMachineViewerData(group_code, project_code);
  const [mounted, setMounted] = useState(false);
  const [equipmentWithData, setEquipmentWithData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSyncModalOpen, setIsSyncModalOpen] = useState(false); // 추가된 부분
  const [newMachineName, setNewMachineName] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // 'success', 'error', 'warning', 'info'
  });
  const openSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };
  const closeSnackbar = () => {
    setSnackbar({
      ...snackbar,
      open: false,
    });
  };
  const handleModalOpen = () => setIsModalOpen(true);
  const handleModalClose = () => {
    setIsModalOpen(false);
    setNewMachineName("");
  };
  const handleSyncModalOpen = () => setIsSyncModalOpen(true);
  const handleSyncModalClose = () => setIsSyncModalOpen(false);
  const handleAddMachine = () => {
    if (!newMachineName.trim().length) {
      toast.error(`장비명을
      입력해 주세요.`);
      return;
    }
    postInsightwinMachineMaster(newMachineName.trim(), setUpdateStatus);
    handleModalClose();
  };
  useEffect(() => {
    setMounted(true);
  }, []);
  useEffect(() => {
    if (equipment && equipment.length > 0) {
      const enhancedEquipment = equipment.map((item) => ({
        ...generateRandomData(item.name, item.machine_id, item.original_name),
      }));
      setEquipmentWithData(enhancedEquipment);
    }
  }, [equipment]);
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  if (loading) {
    return <Loading />;
  }
  return (
    <>
      <S.PageContainer>
        <S.HeaderContainer>
          <S.Title variant="h4" sx={{ display: "flex", alignItems: "center" }}>
            장비 정보 관리 &nbsp;
            <Tooltip
              title="이동"
              sx={{ cursor: "pointer" }}
              onClick={() =>
                goToHelpLink(
                  "https://help.ese-tech.com/ko/scheduler#h-7-%EA%B8%B0%EC%A4%80%EC%A0%95%EB%B3%B4-%EC%9E%A5%EB%B9%84-%EA%B4%80%EB%A6%AC"
                )
              }
            >
              <HelpOutlineIcon />
            </Tooltip>
          </S.Title>
          <div style={{ display: "flex", gap: "1rem" }}>
            <CustomButton
              onClick={handleSyncModalOpen}
              startIcon={<SyncIcon />}
            >
              동기화
            </CustomButton>
            {/* <Button
              color="primary"
              variant="contained"
              onClick={handleSyncModalOpen} // 변경된 부분
            >
              동기화
            </Button> */}
            {/* <Button
              color="primary"
              variant="contained"
              onClick={handleModalOpen}
              sx={{
                borderRadius: "8px",
                boxShadow: 2,
                px: 3,
              }}
            >
              장비 추가
            </Button> */}
          </div>
        </S.HeaderContainer>
        <S.ContentContainer>
          <Grid container spacing={3} sx={{ boxShadow: "none !important" }}>
            {equipmentWithData.map((equipment, index) => (
              <Grid item xs={12} sm={6} lg={4} key={equipment.machine_id}>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: mounted ? 1 : 0, y: mounted ? 0 : 20 }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                  style={{ boxShadow: "none" }}
                >
                  <EquipmentCard
                    equipment={equipment}
                    setUpdateStatus={setUpdateStatus}
                    group_code={group_code}
                    project_code={project_code}
                    openSnackbar={openSnackbar}
                  />
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </S.ContentContainer>

        {/* 장비 추가 모달 */}
        <Modal open={isModalOpen} onClose={handleModalClose}>
          <S.ModalContainer>
            <S.ModalTitle>장비 추가</S.ModalTitle>
            <TextField
              fullWidth
              label="장비명"
              value={newMachineName}
              onChange={(e) => setNewMachineName(e.target.value)}
              autoFocus
              variant="outlined"
              sx={{ mb: 3 }}
            />
            <S.ButtonGroup>
              <Button
                variant="contained"
                onClick={handleAddMachine}
                sx={{ borderRadius: "8px" }}
              >
                추가
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={handleModalClose}
                sx={{ borderRadius: "8px" }}
              >
                취소
              </Button>
            </S.ButtonGroup>
          </S.ModalContainer>
        </Modal>

        {/* 동기화 모달 - 추가된 부분 */}
        <MchSync
          open={isSyncModalOpen}
          onClose={handleSyncModalClose}
          setUpdateStatus={setUpdateStatus}
          openSnackbar={openSnackbar}
          updateStatus={updateStatus}
        />
      </S.PageContainer>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default FactoryEquipmentDashboard;
